// ── AdoraTeam API Service v2 ──

const API_URL = "https://adorateam-api-532602191494.us-central1.run.app";

// ── TOKEN ──
function getToken() {
    try {
        return localStorage.getItem("adorateam_token");
    } catch (e) {
        return null;
    }
}

export function salvarToken(token) {
    localStorage.setItem("adorateam_token", token);
}

export function removerToken() {
    localStorage.removeItem("adorateam_token");
}

// ── REQUEST BASE ──
async function req(path, options = {}) {
    const token = getToken();

    const res = await fetch(API_URL + path, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: "Bearer " + token } : {}),
            ...(options.headers || {})
        }
    });

    let data = {};
    try {
        data = await res.json();
    } catch (e) {}

    if (!res.ok) {
        throw new Error(data.erro || "Erro na requisição");
    }

    return data;
}

// ── AUTH ──
export const auth = {

    cadastro(dados) {
        return req("/api/auth/cadastro", {
            method: "POST",
            body: JSON.stringify(dados)
        });
    },

    cadastroMembro(dados) {
        return req("/api/auth/cadastro-membro", {
            method: "POST",
            body: JSON.stringify(dados)
        });
    },

    validarConvite(invite_code) {
        return req("/api/auth/validar-convite", {
            method: "POST",
            body: JSON.stringify({ invite_code })
        });
    },

    login(email, senha) {
        return req("/api/auth/login", {
            method: "POST",
            body: JSON.stringify({ email, senha })
        });
    },

    me() {
        return req("/api/auth/me");
    },

    atualizarPlano(plano) {
        return req("/api/auth/atualizar-plano", {
            method: "POST",
            body: JSON.stringify({ plano })
        });
    },

    entrarMinisterio(codigo) {
        return req("/api/auth/entrar-ministerio", {
            method: "POST",
            body: JSON.stringify({ codigo })
        });
    }

};

// ── GRUPOS ──
export const grupos = {

    meu() {
        return req("/api/grupos/meu");
    },

    convite(codigo) {
        return req("/api/grupos/convite/" + codigo);
    },

    regenerarCodigo() {
        return req("/api/grupos/regenerar-codigo", {
            method: "POST"
        });
    },

    atualizarInfo(nome, igreja) {
        return req("/api/grupos/info", {
            method: "PUT",
            body: JSON.stringify({ nome, igreja })
        });
    },

    removerMembro(userId) {
        return req("/api/grupos/membro/" + userId, {
            method: "DELETE"
        });
    },

    salvarPermissoes(userId, permissoes) {
        return req("/api/grupos/permissoes/" + userId, {
            method: "PUT",
            body: JSON.stringify(permissoes)
        });
    },

    minhasPermissoes() {
        return req("/api/grupos/permissoes/minhas");
    }

};

// ── MÚSICAS ──
export const musicas = {

    listar() {
        return req("/api/musicas");
    },

    buscar(id) {
        return req("/api/musicas/" + id);
    },

    criar(dados) {
        return req("/api/musicas", {
            method: "POST",
            body: JSON.stringify(dados)
        });
    },

    // alias usado em EditarCifra
    editar(id, dados) {
        return req("/api/musicas/" + id, {
            method: "PUT",
            body: JSON.stringify(dados)
        });
    },

    atualizar(id, dados) {
        return req("/api/musicas/" + id, {
            method: "PUT",
            body: JSON.stringify(dados)
        });
    },

    apagar(id) {
        return req("/api/musicas/" + id, {
            method: "DELETE"
        });
    },

    async uploadAudio(id, campo, arquivo) {
        const token = getToken();

        const form = new FormData();
        form.append("campo", campo);
        form.append("audio", arquivo);

        const res = await fetch(API_URL + "/api/musicas/" + id + "/audio", {
            method: "POST",
            headers: token ? { Authorization: "Bearer " + token } : {},
            body: form
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.erro || "Erro no upload");
        }

        return data;
    },

    async uploadPartitura(id, arquivo) {
        const token = getToken();

        const form = new FormData();
        form.append("partitura", arquivo);

        const res = await fetch(API_URL + "/api/musicas/" + id + "/partitura", {
            method: "POST",
            headers: token ? { Authorization: "Bearer " + token } : {},
            body: form
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.erro || "Erro no upload da partitura");
        }

        return data;
    }

};

// ── EVENTOS ──
export const eventos = {

    listar() {
        return req("/api/eventos");
    },

    criar(dados) {
        return req("/api/eventos", {
            method: "POST",
            body: JSON.stringify(dados)
        });
    },

    // Atualiza dados gerais: título, tipo, data, fotoPaleta, responsavelPaleta
    atualizar(id, dados) {
        return req("/api/eventos/" + id, {
            method: "PUT",
            body: JSON.stringify(dados)
        });
    },

    apagar(id) {
        return req("/api/eventos/" + id, {
            method: "DELETE"
        });
    },

    // Atualiza equipe escalada
    atualizarMembros(id, integrantes) {
        return req("/api/eventos/" + id + "/membros", {
            method: "PUT",
            body: JSON.stringify({ integrantes })
        });
    },

    // Atualiza ordem das músicas
    atualizarSetlist(id, setlist) {
        return req("/api/eventos/" + id + "/setlist", {
            method: "PUT",
            body: JSON.stringify({ setlist })
        });
    }

};

// ── REDE ──
export const rede = {

    listar() {
        return req("/api/rede");
    },

    perfil(id) {
        return req("/api/rede/" + id);
    },

    curtir(videoId) {
        return req("/api/rede/videos/" + videoId + "/curtir", {
            method: "POST"
        });
    }

};

// ── PING ──
export function ping() {
    return req("/api/ping");
}